<style lang="sass" scoped>
$textWhiteColor: #fff

.member
  margin-top: 10px

  .member_title
    font-size: 14px
    line-height: 14px
    font-weight: 500
    color: var(--menu-primary-background-colour)

  .member_input
    display: flex
    border: 1px solid rgba(50, 56, 62, .2)
    margin-top: 4px
    border-radius: 4px

    ::v-deep
      .van-cell
        padding: 6px 0 6px 12px
        color: #334455
        border-radius: 4px

  .member_verify
    display: flex
    align-items: center
    height: 38px
    padding: 0 12px
    margin-left: 12px
    font-size: 14px
    font-weight: 500
    border-radius: 4px !important
    color: $textWhiteColor !important
    background: var(--menu-primary-background-colour) !important

.prompt_text
  display: flex
  align-items: center
  font-size: 12px

  .icon
    margin-right: 6px
    font-size: 14px

.success_text
  color: #17A341

.error_text
  color: #B00620

.member_box
  position: relative

::v-deep
  .code_box
    .py_form_item_box
      display: flex
      align-items: flex-end

      .member_input
        flex: 1

  .has_message
    .py_form_item_box
      padding-top: 0

  .py_form_item_box
    padding-bottom: 0
    padding-top: 20px

  .i-form-item-message
    top: 0
    bottom: auto !important

  .van-collapse-item__content
    padding-top: 0
</style>
<template lang="pug">
.member(v-if='venueSpDiscount && venueSpDiscount.enable')
  van-collapse(
    v-model="value"
    accordion,
    :border='false'
  )
    van-collapse-item.van_collapse_item_custom(name='0')
      template(#title)
        .member_title {{ t('have_discount_code', venueSpDiscount.question) }}
      icon(
        slot='right-icon',
        v-if="value === ''",
        :color='buttonColor'
      ) keyboard_arrow_down
      icon(slot='right-icon', v-else, :color='buttonColor') keyboard_arrow_up
      .member_box
        .prompt_text(v-if="isSuccess === 1")
          icon.icon check_circle
          .success_text {{ t('discount_applied', venueSpDiscount.successMessage) }}
        .prompt_text(v-if="isSuccess > 1")
          icon.icon(color='#B00620') error
          .error_text(v-if="isSuccess === 2") {{ t('invalid_discount_code', venueSpDiscount.errorMessage || "Invalid discount code") }}
          .error_text(v-if="isSuccess === 3") {{ t('coupon_conditions_not_met', venueSpDiscount.notPassMessage || "You've not met the coupon code conditions to receive a discount.") }}

        py-form(
          ref='memberForm',
          :model='memberInfo',
          :rules='memberRuleValidate'
        )
          py-form-item(v-if='!isCodeDiscount', prop='memberName')
            .member_input
              van-field(
                v-model='memberInfo.memberName',
                :placeholder='t("enter_full_name", "Enter your full name")'
              )
          py-form-item.code_box(prop='memberNum' :class="{has_message: isSuccess > 0}")
            .member_input
              van-field(
                v-model='memberInfo.memberNum',
                :placeholder='isCodeDiscount ? t("enter_coupon_code", "Enter coupon code") : tParams("enter_member_number", `Enter ${venueSpDiscount.name} number`, { name: venueSpDiscount.name })'
              )
            .member_verify(type="button" @click='clickVerifyMemberNum') {{ t('verify', 'VERIFY') }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { t, tParams } from '@/utils/language'

const memberNameRule = (rule, value, callback) => {
  if (value.length > 40) {
    callback(new Error(t('name_max_length', 'Name must be less than 40 characters')))
  }
  callback()
}
@Component({
  props: {
    venueSpDiscount: {
      type: Object,
    },

    member: {
      type: Object
    },

    showMemberInput: [Number, String],

    buttonColor: {
      type: String,
    },

    isCodeDiscount: {
      type: Boolean,
    },

    verifyMemberState: {
      type: Number,
    },

    // Whether to pre fill in the membership code
    // 是否预填写会员码
    isFilledCode: {
      type: Boolean
    }
  },

  watch: {
    showMemberInput: {
      handler(newVal) {
        this.value = newVal.toString()
      },
      immediate: true,
    },

    member: {
      handler(newVal) {
        this.memberInfo = newVal
      },
      immediate: true,
      deep: true
    },

    // The user enters the membership code. Notify Parent Component
    // 用户输入会员码。通知父组件
    memberInfo: {
      handler(newVal) {
        this.$emit('isMemberInfo', newVal)
      },
      immediate: true,
      deep: true
    },

    // Pre fill in the membership code and verify it
    // 预填写会员码，并且校验
    isFilledCode(val) {
      if (val) {
        this.value = '0'
        this.memberInfo = this.member
        this.$nextTick(async() => {
          this.clickVerifyMemberNum()
        })
      }
    }
  },

  computed: {
    /**
     * 是否通过验证
     * @returns {Number} 验证的结果。 1 - 通过，2 - 不通过，3 - 通过，但是不符合优惠条件
     */
    isSuccess() {
      let state = this.verifyMemberState
      const discountAmount = this.$store.state.discountAmount
      if (state === 1 && !discountAmount > 0) state = 3
      return state
    }
  }
})

class OrderItems extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  tParams(key, fallback, params) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return tParams(key, fallback, params)
  }

  value = ''
  memberInfo = {
    memberName: '',
    memberNum: ''
  }

  get memberRuleValidate() {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return {
      memberName: [
        { required: true, message: t('name_required', 'Name is required'), trigger: 'blur' },
        { validator: memberNameRule, trigger: 'blur' },
      ],
      memberNum: [
        {
          required: true,
          message: this.isCodeDiscount ? t('code_required', 'Code is required') : this.venueSpDiscount.name + ' ' + t('number_required', 'number is required'),
          trigger: 'blur',
        },
      ],
    }
  }

  async clickVerifyMemberNum() {
    this.$refs.memberForm.validate(async (valid) => {
      if (!valid) {
        this.$store.commit('clearDiscounts')
      } else {
        this.$emit('clickVerifyMemberNum', this.memberInfo)
      }
    })
  }
}

export default OrderItems
</script>
